import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

export function LoginRedirect() {
    const { instance } = useMsal();

    useEffect(() => {
        instance.loginRedirect(loginRequest);
    }, [instance]);

    return <div>Redirecting to login...</div>;
}